import React, { useState, useEffect } from 'react';
import BackgroundImage from 'gatsby-background-image';
import { GiNewspaper } from 'react-icons/gi';
import { useForm } from 'react-hook-form';
import ReCAPTCHA from 'react-google-recaptcha';
import LazyLoad from 'react-lazyload';

import { Link, useI18next } from 'gatsby-plugin-react-i18next';
import { Trans, useTranslation } from 'gatsby-plugin-react-i18next';

const recaptchaRef = React.createRef();

function Newsletter() {
  const { t } = useTranslation();
  const c = useI18next();
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const { register, handleSubmit, watch, errors, formState, setValue, getValues } = useForm();
  const { isSubmitted, isValid } = formState;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const onSubmit = (data) => {
    setIsSubmitting(true);
    data['g-recaptcha-response'] = recaptchaValue;
    fetch('/api/newsletter', {
      method: 'POST',
      body: 'email=' + encodeURIComponent(data.email) + '&g-recaptcha-response=' + data['g-recaptcha-response'],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      redirect: 'follow'
    })
      .then((resp) => {
        console.log(resp);
        if (resp.redirected) {
          window.location.href = resp.url;
        }
      })
      .catch((error) => {
        console.log(error);
        setSuccess('false');
        setError('Internal Error');
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };
  function iss(isSubmitting) {
    return isSubmitting;
  }

  useEffect(() => {
    register({ name: 'captchaToken' }, { required: true });
  });
  function onChange() {
    console.log('recaptcha');
    setRecaptchaValue(recaptchaRef.current.getValue());
    setValue('captchaToken', recaptchaRef.current.getValue());
    clearErrors(['captchaToken']);
  }

  useEffect(() => {
    register({ name: 'captchaToken' }, { required: true });
  });
  return (
    <LazyLoad offset={500}>
      <div className="flex flex-col flex-1 md:justify-center max-w-4xl mx-auto px-4 py-8 md:p-8 w-full">
        <div className="mx-auto shadow rounded to w-full md:w-3/4 border-solid border-t-4 bg-blue-700 p-6 my-2">
          <div className="flex justify-between items-center" />
          <GiNewspaper className="float-right" color="rgb(255, 255, 255, 0.3)" size={42} />
          <h3 className="text-2xl text-white font-black font-sans leading-normal">
            <Trans i18nKey="newsletter">Newsletter</Trans>
          </h3>
          <p className="py-10">
            <iframe
              frameborder="0"
              height="150"
              scrolling="no"
              src={t(`https://elcrimen.substack.com/embed`)}
              style={{ border: `1px solid #111`, background: `rgb(43, 108, 176)` }}
              title="Newsletter signup"
              width="100%"
            ></iframe>
          </p>
        </div>
      </div>
    </LazyLoad>
  );
}

export default Newsletter;
